/**
 * This file is autogenerated. Do not edit manually.
 * Run `yarn generate:feature-flags` to regenerate.
 */

export enum FeatureFlag {
  ENABLE_SUBFLOW = 'enable-subflow',
  ENABLE_BFCM = 'enable-bfcm',
  COMMIT_AVATAX_TRANSACTIONS = 'commit-avatax-transactions',
  SUBFLOW_V2_BOOKS_ADDON_MVP_ENABLED = 'subflow_v2_books_addon_mvp_enabled',
  SUBFLOW_V2_ENABLE_STANDALONE_UPSELL = 'subflow_v2_enable_standalone_upsell',
  SUBFLOW_V2_BOOKS_ADDON_SUPPORTED_LANGUAGES = 'subflow_v2_books_addon_supported_languages',
  SUBFLOW_V2_ENABLE_PREVIOUS_PLAY_ADD_ONS = 'subflow_v2_enable_previous_play_add_ons',
  SUBFLOW_V2_ENABLE_4YO_SCHEDULE = 'subflow_v2_enable_4yo_schedule',
  SUBFLOW_V2_ENABLE_3YO_SCHEDULE = 'subflow_v2_enable_3yo_schedule',
  SUBFLOW_V2_IS_INTL_STORE = 'subflow_v2_is_intl_store',
  UPDATED_CHECKOUT_COPY = 'updated-checkout-copy',
  RETENTION_TEMPORARY_ENABLE_FUND_KIT = 'retention_temporary_enable-fund-kit',
  SUBSCRIPTION_BUILDER_V2 = 'subscription-builder-v2',
  SRS_TEMPORARY_DISABLE_SHOPIFY_ORDERS = 'srs_temporary_disable-shopify-orders',
  MONEY_USER_REFERRAL_CREDIT = 'money-user-referral-credit',
  MUTUALLY_EXCLUSIVE_SUB_FLOW_EXPERIMENT_PREREQ = 'mutually-exclusive-sub-flow-experiment-prereq',
  RETENTION_PERMANENT_ENABLE_EASYPOST_TRACKING = 'retention_permanent-enable-easypost-tracking',
  RETENTION_PERMANENT_ENABLE_ADDRESS_HOLDS = 'retention_permanent-enable-address-holds',
  MUTUALLY_EXCLUSIVE_HOMEPAGE_EXPERIMENT_PREREQ = 'mutually-exclusive-homepage-experiment-prereq',
  RETENTION_PERMANENT_EXPIRED_HOLDS_CRON_SCHEDULE = 'retention_permanent-expired-holds-cron-schedule',
  RETENTION_PERMANENT_REMORSE_INITIAL_FULFILLMENT_DELAY = 'retention_permanent-remorse-initial-fulfillment-delay',
  RETENTION_PERMANENT_REMORSE_RECURRING_FULFILLMENT_DELAY = 'retention_permanent-remorse-recurring-fulfillment-delay',
  RETENTION_TEMPORARY_ALLOW_UNVERIFIED_ADDRESS_FULFILLMENT = 'retention_temporary-allow-unverified-address-fulfillment',
  READING_SKILL_SET = 'reading-skill-set',
  RETENTION_PERMANENT_ADDRESS_VERIFICATION = 'retention_permanent-address-verification',
  RETENTION_ENABLE_SMS_MESSAGING = 'retention-enable-sms-messaging',
  RETENTION_LIFECYCLE_EMAIL_SUPPRESSION = 'retention_lifecycle-email-suppression',
  RETENTION_ENABLE_EMAILS_AND_PUSH_NOTIFICATIONS = 'retention-enable-emails-and-push-notifications',
  GROWTH_ENABLE_WHATS_APP_WIDGET = 'growth_enable-whats-app-widget',
  GROWTH_INTERMEDIATE_STEP_BUILDER = 'growth-intermediate-step-builder',
  GROWTH_CHECKOUT_DISCOUNT_CODE_FIELD_DEFAULT_STATE = 'growth_checkout-discount-code-field-default-state',
  GROWTH_ENABLE_FORGET_SOMETHING_BANNER = 'growth-enable-forget-something-banner',
  GROWTH_ENABLED_PICK_UP_WHERE_YOU_LEFT_OFF_BANNER = 'growth-enabled-pick-up-where-you-left-off-banner',
  GROWTH_TEMPORARY_USER_REPOSITORY_CACHING = 'growth_temporary-user-repository-caching',
  MONEY_ENABLE_BFCM_2024 = 'money_enable-bfcm-2024',
  RETENTION_ENABLE_SUBSCRIPTION_V_2_PAGE = 'retention-enable-subscription-v-2-page',
  GROWTH_TEMPORARY_ENABLE_INTERMEDIATE_STEP_OBJECT = 'growth_temporary_enable-intermediate_step_object',
  RETENTION_ENABLE_EXTENSION_REACTIVATION_V_2 = 'retention_enable-extension-reactivation-v-2',
  GROWTH_ENABLE_TRUSTED_SHOP_WIDGET = 'growth_enable-trusted-shop-widget',
  GROWTH_ENABLE_CHAT_WIDGET = 'growth_enable-chat-widget',
  SAMPLE_FEATURE = 'sample-feature',
  GROWTH_SERVER_SIDE_CHECKOUT_ANALYTICS = 'growth-server-side-checkout-analytics',
  RETENTION_ENABLE_POWERED_BY_PG_LOGO = 'retention-enable-powered-by-pg-logo',
  GROWTH_CHECKOUT_AUTO_APPLY_CODE = 'growth_checkout-auto-apply-code',
  RETENTION_ENABLE_INTERMEDIATE_CART_UPSELL_PAGE = 'retention_enable-intermediate-cart-upsell-page',
  MONEY = 'money',
  MONEY_ENABLE_BFCM_2024_HOMEPAGE = 'money-enable-bfcm-2024-homepage',
  RETENTION_ENABLE_ADA = 'retention-enable-ada',
  RETENTION_ENABLE_WHATS_APP_WIDGET = 'retention-enable-whats-app-widget',
  MONEY_ENABLE_BACKORDER_MESSAGE_THE_MUSIC_SET = 'money_enable-backorder-message-the-music-set',
  GROWTH_ENABLE_DELIVERY_EXPECTATIONS = 'growth_enable-delivery-expectations',
  TRC_ACCESS = 'trc-access',
  GROWTH_PDP_FLEXIBILITY = 'growth_pdp-flexibility',
  RETENTION_ENABLE_ADA_GREETING = 'retention-enable-ada-greeting',
  GROWTH_20241211_A_A = 'growth_20241211-A-A',
  GROWTH_ENABLE_LINK_PAYMENT = 'growth_enable-link-payment',
  GROWTH_CHECKOUT_EXPERIMENT_V4_LIVE = 'growth_checkout-experiment-v4-live',
  GROWTH_CHECKOUT_EXPERIMENT_V5_LIVE = 'growth_checkout-experiment-v5-live',
  SUB_SQUAD_ADA_ENVIRONMENT = 'sub-squad-ada-environment',
  SUB_SQUAD_ENABLE_THE_READING_CLUB_LP = 'sub-squad-enable-the-reading-club-lp',
  MONEY_CONTENTFUL_DRAFT_MODE = 'money_contentful-draft-mode',
  SUB_SQUAD_ENABLE_SHOP_ALL_NAVIGATION_DROPDOWN = 'sub-squad-enable-shop-all-navigation-dropdown',
  SRS_ALLOW_0_DISCOUNT_CODE = 'srs-allow-0-discount-code',
  SUB_SQUAD_ENABLE_TABS_ON_RSS_PDP = 'sub-squad-enable-tabs-on-rss-pdp',
  MONEY_SUBCA_MVP = 'money_subca_mvp',
  MONEY_ENABLE_FULFILLABLE_LINE_ITEMS = 'money_enable-fulfillable-line-items',
  SUB_SQUAD_ENABLE_BIG_PUF = 'sub-squad-enable-big-puf',
  MONEY_INCREASE_PERCEIVED_PK_SUB_VALUE = 'money_increase-perceived-pk-sub-value',
  SUB_SQUAD_ENABLE_TARIFF = 'sub-squad-enable-tariff',
  MONEY_1576_ENABLE_SUBSCRIBE_AND_SAVE = 'money-1576_enable-subscribe-and-save',
  MONEY_1699_FLAGGED_FREE_COURSES = 'money-1699-flagged-free-courses',
  MONEY_ENABLE_SUBSCRIBE_AND_SAVE = 'money_enable-subscribe-and-save',
  SUB_SQUAD_ENABLE_BABYLIST_SHIPPING_ADJUSTMENT = 'sub-squad-enable-babylist-shipping-adjustment',
  MONEY_1796_OVERWRITE_DUPLICATE_VARIANT_ITEMS_IN_CART = 'money-1796-overwrite-duplicate-variant-items-in-cart',
  MONEY_ENABLE_INDIVIDUAL_PLAYTHINGS = 'money_enable-individual-playthings',
  MONEY_1895_PLAY_KIT_SUBSCRIBER_STATUS_UPDATE = 'MONEY-1895-play-kit-subscriber-status-update',
  SUB_SQUAD_COMPONENT_LIBRARY = 'sub-squad-component-library',
  TEMPORARY_MONEY_BATH_SET_LAUNCH = 'temporary_money-bath-set-launch',
  MONEY_1927_SUB_ENGINE_SUBSCRIBER_STATUS_UPDATE = 'MONEY-1927-sub-engine-subscriber-status-update',
  MONEY_BATH_SET_PDP = 'money_bath-set-pdp',
  TEMPORARY_MONEY_LIST_SEGMENT_POC = 'temporary_money-list-segment-poc',
  MONEY_RESALE_VALUE_ON_PLK_PDP = 'money_resale-value-on-plk-pdp',
  HIDE_URL_PRODUCTS_BATH_SET_WITH_FEATURE_FLAG = 'HIDE_URL_products-bath-set-with-feature-flag',
  HIDE_URL_PRODUCTS_THE_BATH_SET = 'HIDE_URL_products-the-bath-set',
  SUB_SQUAD_ENABLE_ERC_PAUSE_STATE = 'sub-squad-enable-erc-pause-state',
  MONEY_RESALE_VALUE_ON_PLK_PDP_V2 = 'money_resale-value-on-plk-pdp-v2',
  MONEY_BFCM_MODE_2025 = 'money_bfcm-mode-2025',
  SUB_SQUAD_ENABLE_DISCOUNT_DOLLAR_SAVINGS = 'sub-squad-enable-discount-dollar-savings',
  SUB_SQUAD_NO_DOB_ABC = 'sub-squad-no-dob-abc',
  SUB_SQUAD_PK_YOTPO_OVERRIDE = 'sub-squad-pk-yotpo-override',
  MONEY_ACCEPT_CLUTCH_GIFTCARDS_IN_PLAYGENIUS = 'money-accept-clutch-giftcards-in-playgenius',
  SUB_SQUAD_NO_DOB_2187 = 'sub-squad-no-dob-2187',
  SUB_SQUAD_ERC_CTA_2146 = 'sub-squad-erc-cta-2146',
  SUB_SQUAD_PUF_PRICING_2193 = 'sub-squad-puf-pricing-2193',
  MONEY_2178_UI_ENABLE_MULTIPLE_GIFT_CARDS = 'money-2178-ui-enable-multiple-gift-cards',
  HIDE_URL_PRODUCTS_MINI_KITS = 'HIDE_URL_products-mini-kits',
  HIDE_URL_PRODUCTS_TODDLER_FOOD_PREP_MINI_KIT = 'HIDE_URL_products-toddler-food-prep-mini-kit',
  HIDE_URL_PRODUCTS_TODDLER_ROUTINES_MINI_KIT = 'HIDE_URL_products-toddler-routines-mini-kit',
  HIDE_URL_PRODUCTS_TODDLER_EMOTIONS_MINI_KIT = 'HIDE_URL_products-toddler-emotions-mini-kit',
  HIDE_URL_PRODUCTS_TODDLER_SEQUENCING_MINI_KIT = 'HIDE_URL_products-toddler-sequencing-mini-kit',
  HIDE_URL_PRODUCTS_TODDLER_SORT_MATCH_MINI_KIT = 'HIDE_URL_products-toddler-sort-match-mini-kit',
  HIDE_URL_PRODUCTS_TODDLER_MOVEMENT_MINI_KIT = 'HIDE_URL_products-toddler-movement-mini-kit',
  HIDE_URL_PRODUCTS_BABY_CAUSE_EFFECT_MINI_KIT = 'HIDE_URL_products-baby-cause-effect-mini-kit',
  HIDE_URL_PRODUCTS_BABY_MOVEMENT_MINI_KIT = 'HIDE_URL_products-baby-movement-mini-kit',
  HIDE_URL_PRODUCTS_BABY_SENSORY_MINI_KIT = 'HIDE_URL_products-baby-sensory-mini-kit',
  MONEY_2209_DISCOUNT_STACKING_PREVENTION = 'money-2209-discount-stacking-prevention',
  HIDE_URL_PRODUCTS_THE_NEWBORN_GIFT_SET = 'HIDE_URL_products-the-newborn-gift-set',
  HIDE_URL_PRODUCTS_THE_PLAY_SPACE_COVER = 'HIDE_URL_products-the-play-space-cover',
  SUB_SQUAD_NAVIGATION_REDESIGN_2353 = 'sub-squad-navigation-redesign-2353',
  MONEY_BFCM_DISCOUNT_PLAY_KIT_PDP = 'money_bfcm_discount_play_kit_pdp',
  MONEY_EARLY_DEC_SUB_CAMPAIGN = 'money_early-dec-sub-campaign',
  MONEY_BFCM_DISCOUNT_PLAY_KIT_PDP_LARGE = 'money_bfcm_discount_play_kit_pdp_large',
  MONEY_PUF_DISCOUNT_PLAY_KIT_PDP = 'money-puf-discount-play-kit-pdp',
  MONEY_PROMOTION_CAMPAIGN = 'money_promotion_campaign',
  SUB_SQUAD_CANCEL_SAVER_2348 = 'sub-squad-cancel-saver-2348',
  SUB_SQUAD_BOOKS_OPT_OUT = 'sub-squad-books-opt-out',
  SUB_SQUAD_ERC_LP_HIDE_VALUE_PROP = 'sub-squad-erc-lp-hide-value-prop',
  SUB_SQUAD_SUBFLOW_KIT_SELECTION_EXPERIMENT = 'sub-squad-subflow-kit-selection-experiment',
  MONEY_HIDE_BOOK_BUNDLE_ADDON = 'money_hide-book-bundle-addon',
  MONEY_2528_INVOICE_PREFLIGHT_CHECK = 'MONEY-2528-invoice-preflight-check',
  SUB_SQUAD_BFCM_PROMO_CREDITS_BANNER = 'sub-squad-bfcm-promo-credits-banner',
  HIDE_URL_PRODUCTS_THE_PLAY_KITS_THE_CONNECTOR = 'HIDE_URL_products-the-play-kits-the-connector',
  HIDE_URL_PRODUCTS_THE_PLAY_KITS_THE_EXAMINER = 'HIDE_URL_products-the-play-kits-the-examiner',
  HIDE_URL_PRODUCTS_THE_PLAY_KITS_THE_PERSISTER = 'HIDE_URL_products-the-play-kits-the-persister',
  HIDE_URL_PRODUCTS_THE_PLAY_KITS_THE_PLANNER = 'HIDE_URL_products-the-play-kits-the-planner',
  SUB_SQUAD_PUF_ON_PDP = 'sub-squad-puf-on-pdp',
  MONEY_2694_ALLOW_FRONT_END_OVERRIDE = 'MONEY-2694-allow-front-end-override',
  SUB_SQUAD_AUTH_PERFORMANCE_EXPERIMENT = 'sub-squad_auth-performance-experiment',
  SUB_SQUAD_REMOVE_SINGLE_PLAY_KIT = 'sub-squad-remove-single-play-kit',
  MONEY_2693_SHOPIFY_SYNC_GRAPHQL = 'money-2693-shopify-sync-graphql',
  EVERGREEN_DISCOUNT_MESSAGING = 'evergreen-discount-messaging',
  BOOK_BUNDLE_TO_SUBSCRIPTION_UPSELL = 'book-bundle-to-subscription-upsell',
  KATHARINE_TEST = 'KATHARINE-TEST',
  SUB_SQUAD_REMOVE_SINGLE_PLAY_KIT_TODDLER = 'sub-squad-remove-single-play-kit-toddler',
  SUB_SQUAD_PLAYGENIUS_CHECKOUT_AB_TEST = 'sub-squad-playgenius-checkout-ab-test',
  MONEY_2776_LARGE_PUF_UPDATE = 'money-2776-large-puf-update',
}

export type FeatureFlagValues = {
  'enable-subflow': true | false;
  'enable-bfcm': true | false;
  'commit-avatax-transactions': true | false;
  subflow_v2_books_addon_mvp_enabled: true | false;
  subflow_v2_enable_standalone_upsell: true | false;
  subflow_v2_books_addon_supported_languages: true | false;
  subflow_v2_enable_previous_play_add_ons: true | false;
  subflow_v2_enable_4yo_schedule: true | false;
  subflow_v2_enable_3yo_schedule: true | false;
  subflow_v2_is_intl_store: true | false;
  'updated-checkout-copy': true | false;
  'retention_temporary_enable-fund-kit': true | false;
  'subscription-builder-v2': true | false;
  'srs_temporary_disable-shopify-orders': true | false;
  'money-user-referral-credit': true | false;
  'mutually-exclusive-sub-flow-experiment-prereq': '1' | '2';
  'retention_permanent-enable-easypost-tracking': true | false;
  'retention_permanent-enable-address-holds': true | false;
  'mutually-exclusive-homepage-experiment-prereq': '1' | '2';
  'retention_permanent-expired-holds-cron-schedule':
    | '*/10 * * * *'
    | '*/5 * * * *';
  'retention_permanent-remorse-initial-fulfillment-delay': 24 | 1 | 0 | 2;
  'retention_permanent-remorse-recurring-fulfillment-delay': 24 | 1 | 0 | 2;
  'retention_temporary-allow-unverified-address-fulfillment': true | false;
  'reading-skill-set': true | false;
  'retention_permanent-address-verification': true | false;
  'retention-enable-sms-messaging': true | false;
  'retention_lifecycle-email-suppression': true | false;
  'retention-enable-emails-and-push-notifications': true | false;
  'growth_enable-whats-app-widget': true | false;
  'growth-intermediate-step-builder': true | false;
  'growth_checkout-discount-code-field-default-state': 'open' | 'closed';
  'growth-enable-forget-something-banner': true | false;
  'growth-enabled-pick-up-where-you-left-off-banner': true | false;
  'growth_temporary-user-repository-caching': true | false;
  'money_enable-bfcm-2024': true | false;
  'retention-enable-subscription-v-2-page': true | false;
  'growth_temporary_enable-intermediate_step_object': true | false;
  'retention_enable-extension-reactivation-v-2': true | false;
  'growth_enable-trusted-shop-widget': true | false;
  'growth_enable-chat-widget': true | false;
  'sample-feature': true | false;
  'growth-server-side-checkout-analytics': true | false;
  'retention-enable-powered-by-pg-logo': true | false;
  'growth_checkout-auto-apply-code': true | false;
  'retention_enable-intermediate-cart-upsell-page': true | false;
  money: true | false;
  'money-enable-bfcm-2024-homepage': true | false;
  'retention-enable-ada': true | false;
  'retention-enable-whats-app-widget': true | false;
  'money_enable-backorder-message-the-music-set': true | false;
  'growth_enable-delivery-expectations': 0 | 5;
  'trc-access': true | false;
  'growth_pdp-flexibility': true | false;
  'retention-enable-ada-greeting': true | false;
  'growth_20241211-A-A': 'off' | 'a1' | 'a2';
  'growth_enable-link-payment': true | false;
  'growth_checkout-experiment-v4-live': true | false;
  'growth_checkout-experiment-v5-live': true | false;
  'sub-squad-ada-environment':
    | 'lovevery-nam-gr'
    | 'sandbox-lovevery-gr'
    | 'sandbox-alternative-example'
    | 'lovevery-eu-gr';
  'sub-squad-enable-the-reading-club-lp': true | false;
  'money_contentful-draft-mode': true | false;
  'sub-squad-enable-shop-all-navigation-dropdown': true | false;
  'srs-allow-0-discount-code': true | false;
  'sub-squad-enable-tabs-on-rss-pdp': true | false;
  money_subca_mvp: 'enabled' | 'disabled';
  'money_enable-fulfillable-line-items': true | false;
  'sub-squad-enable-big-puf': true | false;
  'money_increase-perceived-pk-sub-value': 'off' | 'control' | 'treatment';
  'sub-squad-enable-tariff': true | false;
  'money-1576_enable-subscribe-and-save': 'off' | 'control' | 'enabled';
  'money-1699-flagged-free-courses': unknown | unknown | unknown;
  'money_enable-subscribe-and-save': 'off' | 'control' | 'enabled';
  'sub-squad-enable-babylist-shipping-adjustment': true | false;
  'money-1796-overwrite-duplicate-variant-items-in-cart':
    | 'off'
    | 'logging'
    | 'overwrite';
  'money_enable-individual-playthings': true | false;
  'MONEY-1895-play-kit-subscriber-status-update': 'off' | 'logging' | 'enabled';
  'sub-squad-component-library': true | false;
  'temporary_money-bath-set-launch': 'disabled' | 'presale' | 'enabled';
  'MONEY-1927-sub-engine-subscriber-status-update':
    | 'off'
    | 'logging'
    | 'enabled';
  'money_bath-set-pdp': true | false;
  'temporary_money-list-segment-poc':
    | 'disabled'
    | 'playkit_subscriber_variant'
    | 'erc_subscriber_variant';
  'money_resale-value-on-plk-pdp': 'off' | 'control' | 'treatment';
  'HIDE_URL_products-bath-set-with-feature-flag': true | false;
  'HIDE_URL_products-the-bath-set': true | false;
  'sub-squad-enable-erc-pause-state': true | false;
  'money_resale-value-on-plk-pdp-v2': 'off' | 'control' | 'treatment';
  'money_bfcm-mode-2025': 'off' | 'all' | 'presale';
  'sub-squad-enable-discount-dollar-savings': true | false;
  'sub-squad-no-dob-abc': 'a' | 'b' | 'c' | 'off';
  'sub-squad-pk-yotpo-override': true | false;
  'money-accept-clutch-giftcards-in-playgenius': 'on' | 'off';
  'sub-squad-no-dob-2187': 'a' | 'b' | 'off';
  'sub-squad-erc-cta-2146': 'a' | 'b' | 'off';
  'sub-squad-puf-pricing-2193': 'a' | 'b' | 'off';
  'money-2178-ui-enable-multiple-gift-cards': 'off' | 'on';
  'HIDE_URL_products-mini-kits': true | false;
  'HIDE_URL_products-toddler-food-prep-mini-kit': true | false;
  'HIDE_URL_products-toddler-routines-mini-kit': true | false;
  'HIDE_URL_products-toddler-emotions-mini-kit': true | false;
  'HIDE_URL_products-toddler-sequencing-mini-kit': true | false;
  'HIDE_URL_products-toddler-sort-match-mini-kit': true | false;
  'HIDE_URL_products-toddler-movement-mini-kit': true | false;
  'HIDE_URL_products-baby-cause-effect-mini-kit': true | false;
  'HIDE_URL_products-baby-movement-mini-kit': true | false;
  'HIDE_URL_products-baby-sensory-mini-kit': true | false;
  'money-2209-discount-stacking-prevention': true | false;
  'HIDE_URL_products-the-newborn-gift-set': true | false;
  'HIDE_URL_products-the-play-space-cover': true | false;
  'sub-squad-navigation-redesign-2353': 'a' | 'b' | 'c' | 'off';
  money_bfcm_discount_play_kit_pdp: 'off' | 'control' | 'treatment';
  'money_early-dec-sub-campaign': true | false;
  money_bfcm_discount_play_kit_pdp_large:
    | 'off'
    | 'hold'
    | 'control'
    | 'treatment';
  'money-puf-discount-play-kit-pdp': 'off' | 'hold' | 'control' | 'treatment';
  money_promotion_campaign:
    | 'off'
    | 'gwp_sub_shop_credit50'
    | 'gwp_15off_book'
    | 'gwp_test_empty'
    | 'gwp_munchkin_202602';
  'sub-squad-cancel-saver-2348': 'a' | 'b' | 'c' | 'off';
  'sub-squad-books-opt-out': 'off' | 'a' | 'b';
  'sub-squad-erc-lp-hide-value-prop': 'off' | 'a' | 'b';
  'sub-squad-subflow-kit-selection-experiment': 'a' | 'b' | 'off';
  'money_hide-book-bundle-addon': unknown | unknown | unknown;
  'MONEY-2528-invoice-preflight-check': 'off' | 'logging' | 'active';
  'sub-squad-bfcm-promo-credits-banner': 'a' | 'b' | 'off';
  'HIDE_URL_products-the-play-kits-the-connector': true | false;
  'HIDE_URL_products-the-play-kits-the-examiner': true | false;
  'HIDE_URL_products-the-play-kits-the-persister': true | false;
  'HIDE_URL_products-the-play-kits-the-planner': true | false;
  'sub-squad-puf-on-pdp': 'a' | 'b' | 'c' | 'off';
  'MONEY-2694-allow-front-end-override': true | false;
  'sub-squad_auth-performance-experiment': true | false;
  'sub-squad-remove-single-play-kit': 'a' | 'b' | 'off';
  'money-2693-shopify-sync-graphql': true | false;
  'sub-squad-playgenius-checkout-ab-test': 'a' | 'b' | 'off';
  'evergreen-discount-messaging':
    | 'off'
    | 'suppress-messaging'
    | 'show-messaging';
  'KATHARINE-TEST': true | false;
  'sub-squad-remove-single-play-kit-toddler': 'a' | 'b' | 'off';
  'book-bundle-to-subscription-upsell': 'a' | 'off' | 'b';
  'money-2776-large-puf-update': true | false;
};
